module.exports = __webpack_public_path__ + "4f716325b7f7961f0732f44e9a9fc6d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pos/settings/member2.png
// module id = 706
// module chunks = 0